import { render, staticRenderFns } from "./TrialNotice.vue?vue&type=template&id=f2eb1ce8&"
import script from "./TrialNotice.vue?vue&type=script&lang=js&"
export * from "./TrialNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports